(ns practitest.frontend.forms3.instance
  (:require
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.re-frame :refer [partial-dispatch]]
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.components2.grid.common :as gc]
    [practitest.frontend.components2.grid.fields :refer [transform-fields]]
    [practitest.frontend.components2.grid.fields :as gf]
    [practitest.frontend.components2.traceability :as traceability]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
    [practitest.frontend.forms3.entity-form.footer :as footer]
    [practitest.frontend.forms3.entity-form.forms :as f3.forms]
    [practitest.frontend.forms3.entity-form.traceability :as traceability3]
    [practitest.frontend.forms3.entity-form.utils :refer [track!]]
    [practitest.frontend.forms3.instance.events :as instance-events]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(def ^:private entity-type :instance)
(def metadata (get metadata/entities-metadata entity-type))
(def ^:private form-id (get metadata :form-id))
(def edit-permission (get metadata :edit-permissions))
(def delete-permission (get metadata :delete-permissions))

(defn instance-menu []
  (let [instance (:current @(re-frame/subscribe [::subs/entity entity-type]))
        {:keys [id]} instance]
    [{:id (str "instance-" id "-delete")
      :text (get-translation "generic.button.delete" "Delete")
      :icon [icons/mux-trash]
      :disabled? (not (permissions/has-permission? delete-permission))
      :on-click (fn [e]
                  (mixpanel/track "Form Actions" {"Action" "Delete Instance"})
                  (dom/prevent-default e)
                  (track! "Delete entity" entity-type)
                  (when (js/confirm (get-translation "entity.confirm.action-delete" "Are you sure? This Operation cannot be undone."))
                    (re-frame/dispatch [::instance-events/delete-instance id])))}

     {:text (get-translation "instance.button.go-to-test" "Go to Test")
      :on-click (fn [e]
                  (mixpanel/track "Form Actions" {"Action" "Go to Test"}))
      :href (broutes/get-url-view "qtest_designs#edit" {:id (:qtest_design_id instance)})
      :icon [icons/mux-test-library]}]))

(gc/register-field-type!
  ::run-date
  gf/simple-header
  (fn [{:keys [field]} row]
    (get row field))
  (fn [{:keys [field]} row]
    (let [value (get row field)
          formatter-value (fu/formatted-date-time value)]
      [:a {:href (broutes/get-url-view "qtest_runs#edit" {:id (get row :id)})}
       formatter-value]))
  gc/default-search-fn
  gf/compare-date-time)

(gc/register-field-type!
  ::run-type
  gf/simple-header
  (fn [{:keys [field]} row]
    (get row field))
  (fn [{:keys [field]} row]
    (let [value (get row field)]
      (case value
        "ManualRun"
        "Manual"

        ;else
        value)))
  gc/default-search-fn
  gc/default-compare-fn)

(defmethod grid.subs/columns :instance-linked-runs
  [[_current-project entity-fields fields users groups folders test-case-versioning-enabled?] [_ [_entity _]]]
  (concat
    [{:type ::run-date,
      :field :run_date,
      :default-width 140,
      :header "Run Date"}
     {:type ::run-type
      :field :run_type
      :default-width 80,
      :header "Run Type"}
     {:type :text,
      :field :name,
      :default-width 250,
      :autofilter? true,
      :header "Test Name"}
     {:type :run_status,
      :field :status,
      :default-width 100,
      :autofilter? true,
      :header "Run Status"}
     {:type :text,
      :field :tester_user_name
      :default-width 150,
      :header "Tester"}]
    (when test-case-versioning-enabled?
      [{:type :version_label,
        :field :version_label
        :default-width 150,
        :header "Version Label"}])
    (transform-fields []
                      (dissoc (:run entity-fields))
                      fields users groups folders)))

(defn linked-runs-section [form-props]
  (let [run-columns @(re-frame/subscribe [::grid.subs/columns [:instance :instance-linked-runs]])
        fields @(re-frame/subscribe [::subs/fields])
        data @(re-frame/subscribe [::traceability3/traceability])
        sorted-runs-data (vec (sort-by :run-date > (:linked_runs data)))
        current-project-id @(re-frame/subscribe [::subs/current-project-id])
        table-id (str current-project-id "-" "instance-testset-runs-table")
        grid-props (merge {:fields fields
                           :columns run-columns
                           :data sorted-runs-data
                           :resizable? true
                           :per-page-save (reagent/partial grid-storage/save-per-page table-id)
                           :per-page-load (reagent/partial grid-storage/load-per-page table-id)
                           :autofilters-save (reagent/partial grid-session-storage/save-autofilters table-id)
                           :autofilters-load (reagent/partial grid-session-storage/load-autofilters table-id)
                           :sort-order-save (reagent/partial grid-session-storage/save-sort-order table-id)
                           :sort-order-load (reagent/partial grid-session-storage/load-sort-order table-id)
                           :columns-widths-save (reagent/partial grid-storage/save-column-sizes table-id)
                           :columns-widths-load (reagent/partial grid-storage/load-column-sizes table-id)
                           :full-data? true
                           :class "traceability-tab-grid"
                           :empty-table-message [:div.empty-section-grid [:span (get-translation "entity.traceability.no_linked" "No Items Linked")]]
                           :options {:selectable? true}})]
    [traceability3/traceability-section
     (merge form-props
            {:save-collapsed (reagent/partial traceability3/save-collapsed table-id)
             :load-collapsed (reagent/partial traceability3/load-collapsed table-id)})
     :run :runs sorted-runs-data grid-props]))

(defn- form-layout-instance
  [entity-fields]
  (let [nil-or-unavailable? (fn [field]
                              (or (nil? field)
                                  (not (contains? entity-fields field))))

        initial-layout {:title {:fields [{:field :name}]}
                        (:step-parameters f3.entity-form/sections-keys) {}}

        existing-fields (set (f3.forms/flatten-layout initial-layout))
        to-remove? (fn [field]
                     (or (nil-or-unavailable? field)
                         (contains? existing-fields field)))

        filtered-entity-fields (f3.entity-form/filter-entity-fields entity-fields to-remove?)
        filtered-entity-fields-flat (vec (keys filtered-entity-fields))
        entity-sections @(re-frame/subscribe [::subs/entity-sections entity-type])

        update-main-sections (if (some? entity-sections)
                               #(f3.entity-form/update-layout % entity-sections filtered-entity-fields)
                               #(f3.entity-form/update-layout % (:general-info f3.entity-form/sections-keys) filtered-entity-fields-flat "general_info" entity-fields))

        layout (-> initial-layout
                   (update-main-sections)
                   (f3.entity-form/update-layout (:test-versioning f3.entity-form/sections-keys) [] "test_versioning" entity-fields))]
    layout))

(defmethod f3.forms/build-entity-form-layout form-id
  [_ _ _ entity-fields _]
  (form-layout-instance entity-fields))

(defn build-edit-controller []
  {:start (fn [params]
            (let [{:keys [instance-id testset-id project-id]} (:path params)]
              (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []])
              (re-frame/dispatch [::events/set-current-entity-type entity-type])
              (re-frame/dispatch [::subs/set-current-entity-id
                                  entity-type
                                  instance-id])

              (let [fetch-options {:form-id form-id
                                   :entity-type entity-type
                                   :entity-id instance-id
                                   :project-id project-id
                                   :new? false
                                   :testset-in-url? (some? testset-id)
                                   :got-entity-data [::instance-events/got-instance]}]
                (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])
                (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]]))

              ;; Fetch testset as well
              (when testset-id
                (let [fetch-options {:form-id form-id
                                     :entity-type :testset
                                     :entity-id testset-id
                                     :project-id project-id
                                     :new? false}]
                  (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])))

              (re-frame/dispatch [::events/fetch-attachments])
              (re-frame/dispatch [::events/fetch-history])
              (re-frame/dispatch [::common-events/trigger-online-request])
              (mixpanel/track "Grid Actions" {"Action" "Edit Instance"})))
   :stop (fn [_params]
           (re-frame/dispatch [::events/clear-current-entity entity-type])
           (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
           (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []]))
   :identity :parameters})

(re-frame/reg-sub
  ::dirty-fields-override
  (fn []
    [(re-frame/subscribe [::f3.forms/dirty-fields form-id])
     (re-frame/subscribe [::f3.forms/form-state :step-params-instance])])
  (fn [[main-dirty-fields params-form-state]]
    (let [params-dirty (seq (filter :dirty?
                                    (vals (:fields params-form-state))))]
      (concat main-dirty-fields
              (if params-dirty
                [{:id :params}]
                [])))))

(defn run-button [{:keys [dirty-fields base-entity] :as form-props}]
  (let [dirty? (seq @dirty-fields)]
    [buttons/button
     {:primary? true
      :disabled? dirty?
      :on-click (fn [e]
                  (re-frame/dispatch [::instance-events/run-test base-entity]))
      :size "medium"
      :text (get-translation "instance.button.run" "Run")}]))

(defn save-and-run-button [{:keys [dirty-fields] :as form-props} save-form!]
  [buttons/button
   {:primary? true
    :size "medium"
    :on-click (fn [e]
                (mixpanel/track "Form Actions" {"Action" "Save and Run Instance"})
                (save-form! form-props {:save-and-run? true}))
    :text (get-translation "instance.button.save-and-run" "Save and Run")}])

(defn instance-footer-buttons
  [{:keys [dirty-fields] :as form-props} save-form!]
  (let [dirty? (seq @dirty-fields)]
    [:div.m-button-group
     [footer/standard-cancel-button form-props]
     [footer/standard-save-button form-props save-form!]
     (if dirty?
       [save-and-run-button form-props save-form!]
       [run-button form-props])]))

(defn build-tabs
  []
  [(f3.entity-form/general-entity-tab)
   (traceability/build-traceability-tab)
   (f3.entity-form/history-tab)])

(defn main [new?]
  (let [route @(re-frame/subscribe [::router/current-route])
        testset @(re-frame/subscribe [::forms/base-entity :testset])
        instance @(re-frame/subscribe [::forms/base-entity entity-type])
        test (:qtest_design instance)]
    [f3.entity-form/entity-form
     {:new? new?
      :popup-menu (instance-menu)
      :data-entity-type :testset
      :state-key :instances-state
      :entity-type entity-type
      :form-id form-id
      :dirty-fields (re-frame/subscribe [::dirty-fields-override])
      :buttons-override instance-footer-buttons
      :on-save (partial-dispatch [::instance-events/save-instance (:id instance) (:id testset)])
      :on-cancel (partial-dispatch [::instance-events/reset-instance-form new?])
      ;; We will render last breadcrumb ourselves here
      :last-breadcrumb-fn (fn [_props]
                            (if test
                              (str (f3.forms/entity->display-name entity-type) " of "
                                   (f3.forms/entity->display-name :test) " #" (:display_id (:qtest_design instance)) " | " (:name (:qtest_design instance)))
                              (str "Loading")))
      :path-params {:set_id (:id testset)}
      :breadcrumbs [{:href (broutes/get-url-view "suites#edit" {:id (:id testset)})
                     :label (str (f3.forms/entity->display-name :testset) " #" (:display_id testset)
                                 ": " (:name testset))}]
      :instance-section linked-runs-section
      :additional-header-buttons run-button
      :header-tabs (build-tabs)
      :edit-permissions? (permissions/has-permission? edit-permission)
      :field-edit-permissions? {:name false}
      :customization-permissions? (permissions/has-permission? "customization")
      :general-form-inner-tabs {:edit #{:attachments}}
      :default-active-sub-tab :attachments}]))
